import { motion } from 'framer-motion'
import React from 'react'
import { Container } from 'react-bootstrap'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'

export default function Shopping() {
    return (
      <motion.div 
      initial={{ y: -150, opacity: 0}}
      animate={{ y:0, opacity: 1}}
      exit={{ opacity: 0 }}>
        <PageSeo h1="Shopping" />
        <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
        <PageWrapper name={'Shopping'} display={<h1 className="txt-big">Shopping</h1>}>
          <span className="txt-cream txt-shadow">Market and shopping runs with local drivers who know the north coast.</span>
        </PageWrapper>
        <Container className="text-cream mb-5" style={{ maxWidth: '70ch' }}>
          <p>
            Visit craft markets and shopping areas around Ocho Rios, Montego Bay, and Discovery Bay with Reggae Wheels
            transport — ideal for cruise visitors and resort guests.
          </p>
        </Container>
        <Footer></Footer>
      </motion.div>
      )
}
